import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
    state: {
        product_id: 0,
        bundle: null,
        bundle_id: 0,
        selectedBundleItems: null,
        selectedBundleItemsSumm: {summ: 0, discount: 0, summ_discount: 0},
    },
    mutations,
    actions,
    getters
}
